//记得在 src\components\lang\zhLoad.js 里面添加对象
const abnormalPurchOrder = {
};
export default abnormalPurchOrder



// WEBPACK FOOTER //
// ./src/page/bd/order/abnormalPurchOrder/lang/abnormalPurchOrder.zh.js